import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { trackEvent, WHATSAPP_DM_URL } from "@/lib/api";
import { MessageCircle, ArrowUpRight } from "lucide-react";

/**
 * Sticky mobile CTA that fades in after 400px scroll.
 * Only shown on mobile (< sm breakpoint). Never on /admin routes.
 * Adds bottom padding to the page so content is never obscured.
 */
export default function StickyCTA({ reservePath = "/register/weave_leaveout" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Spacer so sticky bar never covers the footer/content on mobile */}
      <div aria-hidden="true" className="h-20 sm:hidden" />

      <div
        className={`fixed inset-x-0 bottom-0 z-40 sm:hidden transition-transform duration-300 ${
          visible ? "translate-y-0" : "translate-y-full"
        }`}
        data-testid="sticky-cta"
      >
        <div className="mx-3 mb-3 rounded-2xl bg-black/95 backdrop-blur border border-[#FF6A1A]/40 shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.35)] p-2.5 flex gap-2">
          <Link
            to={reservePath}
            onClick={() => trackEvent("sticky_reserve_click")}
            className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#FF6A1A] text-black font-bold px-3 py-3 rounded-xl text-sm hover:opacity-90"
            data-testid="sticky-reserve"
          >
            Reserveer plek
            <ArrowUpRight size={14} strokeWidth={2.4} />
          </Link>
          <a
            href={WHATSAPP_DM_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("sticky_whatsapp_click")}
            className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#25D366] text-black font-bold px-3 py-3 rounded-xl text-sm hover:opacity-90"
            data-testid="sticky-whatsapp"
          >
            <MessageCircle size={14} strokeWidth={2.4} />
            Vraag via WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
